export const primaryFont = '"Nunito",sans-serif';

export const typeScale = {
  header1: "1.5rem",
  paragraph: "1rem",
  input: "0.875rem",
  small: "0.75",
};

export const fontWeight = {
  light: "300",
  normal: "400",
  bold: "700",
  maxBold: "900",
};
